import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { acceptApplicantFailed, acceptApplicantSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* acceptApplicant(action) {
  try {
    if (!action.payload || !action.payload.id) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL_V2}/applications/${action.payload.id}/applicant/confirm`;
    const response = yield makeRequest(url, {}, action, 'POST', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(acceptApplicantSuccessful());
      yield call(resolveActionPromise(action, data.data));
    } else {
      const data = yield getBodyJson(response);
      yield put(acceptApplicantFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(acceptApplicantFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
